//import { CNet } from "./CNet"
import { CNetPeer } from "./CNetPeer";
import { CByteArray } from "./CByteArray";
import { CPacket } from "./CPacket";
import { CConfig } from "./CConfig";

declare var window:any;
declare var cordova:any;
declare var liff:any;

export class CGameState {
	public constructor() {}

	public Init():void {}

	public Cleanup():void {}

	public Frame(game:CGameBase):void {}

	public Pause():void {}

	public Resume():void {}

	public ChangeState(game:CGameBase, state:CGameState):void {
		game.ChangeState(state);
	}
}

export class CGameBase extends PIXI.Application {
	public static ERR_DISCONNECT:number = -10000;
	private 	mGStates:CGameState[] = [];
	protected 	m_netPeer:Array<CNetPeer> = new Array<CNetPeer>(2);
	public		m_CPkt:CPacket;
	public		m_isLineApp:boolean;
	protected 	m_isProcessMsg:boolean = true;
	//public mNet:CNet;

	public constructor(gamewd:number, gameht:number, 
						options?: PIXI.IApplicationOptions) {
		super(options);

		this.m_CPkt = null;

		fgui.UIConfig.defaultFont = "Microsoft JhengHei";
		//fgui.UIConfig.verticalScrollBar = "ui://mjCommon/ScrollBarVT";
        //fgui.UIConfig.horizontalScrollBar = "ui://mjCommon/ScrollBarHZ";
        // fgui.UIConfig.popupMenu = "ui://test/PopupMenu";
        // fgui.UIConfig.globalModalWaiting = "ui://test/GlobalModalWaiting";
        // fgui.UIConfig.windowModalWaiting = "ui://test/WindowModalWaiting";

		let modeScale = fgui.StageScaleMode.SHOW_ALL;
		if( this.isMobile() ) modeScale = fgui.StageScaleMode.EXACT_FIT;

		fgui.GRoot.inst.attachTo(this, {
            designWidth: gamewd,
            designHeight: gameht,
			// scaleMode: fgui.StageScaleMode.FIXED_WIDTH,
			//scaleMode: fgui.StageScaleMode.EXACT_FIT,
			scaleMode: modeScale,
			// scaleMode: fgui.StageScaleMode.FIXED_AUTO,
			// scaleMode: fgui.StageScaleMode.SHOW_ALL,
            orientation: fgui.StageOrientation.LANDSCAPE,//.AUTO,
			//orientation: fgui.StageOrientation.AUTO,
            alignV: fgui.StageAlign.TOP,
			// alignH: fgui.StageAlign.LEFT
			//alignV: fgui.StageAlign.MIDDLE,
            alignH: fgui.StageAlign.CENTER
		});

		this.Init();
	}

	public Init(pktSize:number = 4096):void { 
		this.m_isLineApp = false;
		this.m_CPkt = new CPacket(pktSize);
		console.log("Init:"+pktSize);
	}

	public resetPacket():void {
		this.m_CPkt.resetP();
	}

	public SendData(data:CPacket, peer:number = 0):void {
		if ( this.m_netPeer[peer] ) this.m_netPeer[peer].Send(data);
	}

	public SendReliableData(data:CPacket, peer:number = 0):void {
		if ( this.m_netPeer[peer] ) this.m_netPeer[peer].SendReliable(data);
	}

	public ConnectToServer(URL:string, peer:number = 0, errFunc:Function = null):void {
		if( this.m_netPeer[peer] == null ) this.m_netPeer[peer] = new CNetPeer();
		if ( this.m_netPeer[peer] ) {
			var name:Array<string> = ["大廳", "遊戲"];
			this.m_netPeer[peer].Connect(name[peer], URL, errFunc);
		}
	}
	public DisconnectServer(peer:number = 0, showErr:boolean = false):void {
		if ( this.m_netPeer[peer] ) {
			if( showErr == false ) this.m_netPeer[peer].ResetErrorFunc();
			this.m_netPeer[peer].CloseConnect();
			this.m_netPeer[peer] = null;
		}
	}
	public isServerConnect(peer:number = 0):boolean {
		if( this.m_netPeer[peer] ) {
			return this.m_netPeer[peer].isConnected();
		}
		return false;
	}

	public PauseProcessMsg():void {
		this.m_isProcessMsg = false;
	}

	public ResumeProcessMsg():void {
		this.m_isProcessMsg = true;
	}

	public Cleanup():void {
		while ( this.mGStates.length > 0 ) {
			this.mGStates[this.mGStates.length-1].Cleanup();
			//PIXI.utils.clearTextureCache();
			let gs:CGameState = this.mGStates.pop();
			gs = null;
		}
		console.log("Cleanup done.");
	}

	public PushState(state:CGameState):void {
		if ( this.mGStates.length > 0 ) {
			let gs:CGameState = this.mGStates[this.mGStates.length - 1];
			gs.Pause();
		}
		this.mGStates.push(state);
		state.Init();
	}

	public ChangeState(state:CGameState):void {
		var gs:CGameState = null;
		if ( this.mGStates.length > 0 ) {
			gs = this.mGStates.pop();
			gs.Cleanup();
			gs = null;
		}
		this.mGStates.push(state);
		state.Init();
	}

	public PopState():void {
		let gs:CGameState;
		if ( this.mGStates.length > 0 ) {
			this.mGStates[this.mGStates.length-1].Cleanup();
			gs = this.mGStates.pop();
			gs = null;
		}
		if ( this.mGStates.length > 0 ) {
			gs = this.mGStates[this.mGStates.length - 1];
			gs.Resume();
		}
	}

	public SetGObjectCallbackFunc(doc:fgui.GComponent, callbackFunc:PIXI.utils.EventEmitter.ListenerFn, add:Boolean, ts:any) {
		for (let i = 0; i < doc.numChildren; i++) {
            let c = doc.getChildAt(i);
            let cname = c.name;
            if (fgui.utils.StringUtil.startsWith(cname, "btn_")) {
				//console.log(typeof(c));
				//console.log(c.touchable);
				if( !c.touchable ) {
					c.displayObject.interactive = true;
					c.displayObject.buttonMode = true;
				}
				if( add ) c.click(callbackFunc, ts);
				else 	  c.removeClick(callbackFunc, ts);
            }
        }
	}

	public SetGOCallbackFunc(doc:fgui.GComponent, name:string, cnt:number, callbackFunc:PIXI.utils.EventEmitter.ListenerFn, add:Boolean, ts:any) {
		for (let i = 0; i < cnt; i++) {
			let c = doc.getChild(name+i);
			if( !c.touchable ) {
				c.displayObject.interactive = true;
				c.displayObject.buttonMode = true;
			}
			if( add ) c.click(callbackFunc, ts);
			else 	  c.removeClick(callbackFunc, ts);
        }
	}

	public SetGOPartCallbackFunc(doc:fgui.GComponent, startStr:string, cnt:number, callbackFunc:PIXI.utils.EventEmitter.ListenerFn, add:Boolean, ts:any) {
		for (let i = 0; i < doc.numChildren; i++) {
			let c = doc.getChildAt(i);
			if (fgui.utils.StringUtil.startsWith(c.name, startStr)) {
				//console.log(c.name);
				if( !c.touchable ) {
					c.displayObject.interactive = true;
					c.displayObject.buttonMode = true;
				}
				if( add ) c.click(callbackFunc, ts);
				else 	  c.removeClick(callbackFunc, ts);
			}
        }
	}

	public closeWin():void {
		window.opener = null;
		window.open('', '_self');
		window.close();
	}

	async CopyToClipboard(txt:string) {
		//navigator.clipboard.writeText(txt);
		// Navigator clipboard api needs a secure context (https)
		if (navigator.clipboard && window.isSecureContext) {
			await navigator.clipboard.writeText(txt);
		} 
		else {
			// Use the 'out of viewport hidden text area' trick
			const textArea = document.createElement("textarea");
			textArea.value = txt;
				
			// Move textarea out of the viewport so it's not visible
			textArea.style.position = "absolute";
			textArea.style.left = "-999999px";
				
			document.body.prepend(textArea);
			textArea.select();
	
			try {
				document.execCommand('copy');
			} catch (error) {
				console.error(error);
			} finally {
				textArea.remove();
			}
		}
	}

	public isMobile():boolean {
		if (navigator.userAgent.match(/Android/i) || 
			navigator.userAgent.match(/webOS/i) || 
			navigator.userAgent.match(/iPhone/i) || 
			navigator.userAgent.match(/iPad/i) || 
			navigator.userAgent.match(/iPod/i) || 
			navigator.userAgent.match(/BlackBerry/i) || 
			navigator.userAgent.match(/Windows Phone/i)) {
			this.m_isLineApp = navigator.userAgent.indexOf("Line") > -1;
			return true;
		}
		return false;
	}

	public LINESendMsg(url:string, msg:string):void {
		var URL:string;

		if( CConfig.gameTarget != "H5" ) {
			let options = {
				message: msg, // not supported on some apps (Facebook, Instagram)
				url: url,
				appPackageName: 'jp.naver.line.android', // Android only, you can provide id of the App you want to share with
			  };
			window.plugins.socialsharing.shareWithOptions(options, function(){
				console.log("socialsharing success !!");
			}, function(){
				console.log("socialsharing failed !!");
			});
			return;
		}
		console.log("userAgent:"+navigator.userAgent);
		if (this.isMobile()) {
			// if( this.m_isLineApp ) {
			// 	var txt:string = url+"\n\n"+msg;
			// 	const messages = [{
			// 			type: "text",
			// 			text: txt
			// 			}];
			// 	liff.shareTargetPicker(messages)
			// 		.then(function(res) {
			// 			console.log(res);
			// 		}).catch(function(error) {
			// 			alert(error);
			// 		});
			// }
			// else {
				URL = "https://line.me/R/share?text=";
				var text:string = url+"\n\n"+msg;
				URL += encodeURIComponent(text);
				console.log("mobile");
			// }
		}
		else {
			URL = "https://social-plugins.line.me/lineit/share?url=";
			URL += encodeURIComponent(url);
			URL += "&text=";
			URL += encodeURIComponent(msg);
			console.log("desktop");
		}
		const myWindow = window.open(URL, "_blank");
		// const checkInterval = setInterval(function() {
		// 	if (myWindow && myWindow.closed) {
		// 		// 停止計時器
		// 		clearInterval(checkInterval);
				
		// 		// 在此執行視窗關閉後的動作
		// 		alert('子視窗已經被關閉！');
		// 		// 例如：解除父視窗的遮罩或重新載入資料
		// 	}
		// }, 1000);
		//cordova.InAppBrowser.open(URL);
		// let myWidth = 960;
		// let myHeight = 540;
		// var left = (screen.width - myWidth) / 2;
        // var top = (screen.height - myHeight) / 4;
        // var WebWnd = window.open(URL, "LINE分享", 'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=' + myWidth + ', height=' + myHeight + ', top=' + top + ', left=' + left);
	}

	public TakeScreenshot():void {
		if( CConfig.gameTarget == "App" ) this.appTakeScreenshot();
		else {
			//wait = true;
			const d = new Date();
			let text = d.toLocaleString("ja-JP");
			let name = "screenshot" + text.replace(/[/: ]/g, "");
			this.renderer.plugins.extract.canvas(this.stage).toBlob((b) => {
				const a = document.createElement('a');
				document.body.append(a);
				a.download = name;
				a.href = URL.createObjectURL(b);
				a.click();
				a.remove();
			}, 'image/png');
		}
	}

	public appTakeScreenshot():void {
		const d = new Date();
		let text = d.toLocaleString("ja-JP");
		let name = "screenshot" + text.replace(/[/: ]/g, "");
		const url = this.renderer.plugins.extract.base64(this.stage);
		var params = {data: url, prefix: 'Screenshot_', format: 'PNG', quality: 80, mediaScanner: true};
    	window.imageSaver.saveBase64Image(params,
			function (filePath) {
				console.log('File saved on ' + filePath);
			},
			function (msg) {
				console.error(msg);
			}
		);
	}
	
	public toggleFullScreen():void {
		let doc:any;
		doc = window.document;
		if ( !doc.fullscreenElement && // alternative standard method
			!doc.mozFullScreenElement &&
			!doc.webkitFullscreenElement &&
			!doc.msFullscreenElement ) {
			// current working methods
			if (doc.documentElement.requestFullscreen) {
				doc.documentElement.requestFullscreen();
			} 
			else if (doc.documentElement.msRequestFullscreen) {
				doc.documentElement.msRequestFullscreen();
			} 
			else if (doc.documentElement.mozRequestFullScreen) {
				doc.documentElement.mozRequestFullScreen();
			} 
			else if (doc.documentElement.webkitRequestFullscreen) {
				doc.documentElement.webkitRequestFullscreen(
					(<any>Element).ALLOW_KEYBOARD_INPUT,
				);
			}
			screen.orientation['lock']('landscape');
			//window.screen.orientation.lock('landscape');
		} 
		else {
			if (doc.exitFullscreen) {
				doc.exitFullscreen();
			} 
			else if (doc.msExitFullscreen) {
				doc.msExitFullscreen();
			} 
			else if (doc.mozCancelFullScreen) {
				doc.mozCancelFullScreen();
			} 
			else if (doc.webkitExitFullscreen) {
				doc.webkitExitFullscreen();
			}
		}
		// var doc = window.document;
		// var docEl = doc.documentElement;
	  
		// var requestFullScreen = docEl.requestFullscreen;
		// var cancelFullScreen = doc.exitFullscreen;
		// if ( !doc.fullscreenElement ) {
		//     requestFullScreen.call(docEl);
		// } 
		// else {
		//     cancelFullScreen.call(doc);
		// }
	}

	public DoXmlHttp(mode:string, url:string, data:any, cbSuccess:Function, cbError:Function=null):void {
		var xmlhttp = new XMLHttpRequest();
		xmlhttp.onreadystatechange = function () {
			if (xmlhttp.readyState == 4) {
				if (xmlhttp.status == 200) {
					//console.log(xmlhttp.responseText);
					if( cbSuccess != null ) cbSuccess(xmlhttp.responseText);
				}
				else {
					console.log(xmlhttp.status);
					if( cbError != null ) cbError("XMLHttpRequest Error !! "+xmlhttp.statusText);
				}
			}
		}
		xmlhttp.open(mode, url, true);
		if( data != null ) xmlhttp.send(data);
		else xmlhttp.send();
	}

	public switchTextField2HTMLText(com:fgui.GComponent, name:string, text:string):void {
		let txt = com.getChild(name) as fgui.GTextField;
		let text2:PIXI.HTMLText;
		if( txt ) {
			text2 = new PIXI.HTMLText(text);
			text2.style.fontSize = txt.fontSize;
			text2.style.fill = txt.color;
			text2.style.wordWrap = true;
			text2.style.wordWrapWidth = txt.width;
			text2.x = txt.x;
			text2.y = txt.y;
			text2.name = name;
			com.removeChild(txt, true);
			com.displayListContainer.addChild(text2);
		}
		else {
			text2 = com.displayListContainer.getChildByName(name) as PIXI.HTMLText;
			if( text2 ) {
				text2.text = text;
				text2.updateText();
			}
		}
		com.setBounds(0, 0, text2.width, text2.height);
	}

	// returns a random number between min (included) and max (excluded)
	public static GetRand(min:number, max:number):number {
		return Math.floor(Math.random() * (max - min) ) + min;
	}

	public static CompareVersion(v1:string, v2:string):boolean {
		var ret = false;
		var v1a = v1.split(".");
		var v2a = v2.split(".");
		let i, n1, n2;
		for( i = 0; i < v1a.length; i ++ ) {
			n1 = parseInt(v1a[i]);
			n2 = parseInt(v2a[i]);
			if( n1 > n2 ) {
				ret = true;
				break;
			}
			else if( n1 < n2 ) {
				break;
			}
		}
		return ret;
	}

	public PlayTransition(parent:fgui.GComponent, tname:string, Callback:Function = null, val:number = 0):void {
		let t = parent.getTransition(tname);
		if( Callback ) {
			t.play(function() {
				Callback(val);
			});
		}
		else 
			t.play();
	}

	protected ProcessNetMessage(p:CByteArray, peer:number):number {
		return 1;
	}

	public DoFrame():void {
		for ( var i:number = 0; i < this.m_netPeer.length; i ++ ) {
			if ( this.m_netPeer[i] != null ) {
				this.m_netPeer[i].processReliablePackets();
			}
		}
		if( this.m_isProcessMsg ) {
			for ( var i:number = 0; i < this.m_netPeer.length; i ++ ) {
				//if ( this.m_netPeer[i] != null && this.m_netPeer[i].isConnected() ) {
				if ( this.m_netPeer[i] != null ) {
					var pkt:CByteArray = this.m_netPeer[i].GetRecvPacket();
					if ( pkt ) {
						var rn:number = this.ProcessNetMessage(pkt, i);
						this.m_netPeer[i].DeallocatePacket(pkt);
						if ( rn == CGameBase.ERR_DISCONNECT ) {
							console.log("***** ERR_DISCONNECT !!!");
							this.DisconnectServer(i);
						}
					}
				}
			}
		}
		if ( this.mGStates.length > 0 ) {
			let gs = this.mGStates[this.mGStates.length - 1];
			gs.Frame(this);
		}
	}

	public render(): void {
		//console.log("render ...");
		super.render();
		this.DoFrame();
	}
}
